export const common = {
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    about: 'Acerca de',
    history: 'Historia',
    contact: 'Contacto'
  },
  hero: {
    title: 'Certificación y Asesoría Técnica con',
    titleHighlight: 'Excelencia',
    description: 'Apoyo técnico completo para certificar sus productos con agilidad y confianza. Especialistas en INMETRO, ANATEL, ANVISA y registro de fabricantes.',
    ctaPrimary: 'Solicitar Consultoría',
    ctaSecondary: 'Nuestros Servicios',
    yearsExperience: 'Años de Experiencia',
    compliance: 'Conformidad'
  },
  services: {
    title: 'Nuestros Servicios',
    subtitle: 'Soluciones completas en certificación y asesoría técnica para garantizar la conformidad de sus productos',
    inmetro: {
      title: 'Certificación INMETRO',
      description: 'Certificación completa de productos ante INMETRO, incluyendo eficiencia energética, seguridad y calidad. Seguimiento de todo el proceso de evaluación de conformidad con experiencia técnica especializada.'
    },
    anatel: {
      title: 'Homologación ANATEL',
      description: 'Homologación de equipos de telecomunicaciones ante ANATEL. Asesoría completa para productos que utilizan radiofrecuencia, garantizando conformidad con las normas técnicas brasileñas.'
    },
    anvisa: {
      title: 'Registro ANVISA',
      description: 'Registro de productos ante ANVISA, incluyendo equipos médicos, cosméticos y productos para la salud. Soporte técnico especializado en regulación sanitaria y documentación técnica.'
    },
    suppliers: {
      title: 'Registro de Proveedores',
      description: 'Asesoría completa para registro de fabricantes en los organismos reguladores. Preparación de documentación técnica, adecuación de procesos productivos y seguimiento de auditorías.'
    },
    testing: {
      title: 'Seguimiento de Pruebas',
      description: 'Seguimiento técnico de ensayos y pruebas en laboratorios acreditados. Análisis de informes, identificación de no conformidades y orientación para adecuaciones necesarias.'
    },
    consulting: {
      title: 'Consultoría Especializada',
      description: 'Consultoría técnica en evaluación de conformidad, eficiencia energética y normas técnicas. Soporte estratégico para adecuación de productos a las exigencias regulatorias brasileñas.'
    }
  },
  about: {
    title: 'Acerca de APL Consultoría',
    description1: 'APL Consultoría y Asesoría Técnica está enfocada en proporcionar apoyo técnico completo para clientes que buscan certificar sus productos con agilidad y confianza.',
    description2: 'Con más de 19 años de experiencia en certificaciones técnicas y regulatorias, ofrecemos soporte especializado en INMETRO, ANATEL, ANVISA y registro de fabricantes.',
    description3: 'Nuestra experiencia abarca desde el seguimiento de pruebas y ensayos hasta la consultoría especializada en evaluación de conformidad, garantizando que sus productos cumplan con todos los requisitos regulatorios brasileños.',
    yearsExperience: 'Años de Experiencia',
    complianceGuaranteed: 'Conformidad Garantizada',
    badge: 'Especialista en Certificación y Evaluación de Conformidad'
  },
  experience: {
    title: 'Trayectoria Profesional',
    subtitle: 'Desde 2005, dedicado al área de certificaciones técnicas y regulatorias',
    timeline: [
      {
        period: '2005 - 2016',
        title: 'Responsable Técnico en INMETRO',
        description: 'Responsable técnico en programas de evaluación de conformidad en la Dirección de Evaluación de Conformidad – DConf – en INMETRO.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordinador de Comisiones Técnicas',
        description: 'Coordinador de la Comisión Técnica en Eficiencia Energética de Motores Eléctricos, Bombas Centrífugas, Iluminación, Acondicionadores de Aire, Microondas, Televisores, Ventiladores, Transformadores de Distribución y Refrigeradores.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordinador Técnico en Electrodomésticos',
        description: 'Coordinador de la Comisión Técnica en Electrodomésticos y Similares, garantizando estándares de calidad y seguridad.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordinador Técnico del CGIEE - MME',
        description: 'Coordinador Técnico del Comité Técnico de Electrodomésticos del Comité Gestor de Indicadores y Niveles de Eficiencia Energética – CGIEE – Ministerio de Minas y Energía – MME.'
      },
      {
        period: '2009 - 2016',
        title: 'Coordinador Técnico Brasileño en COPANT',
        description: 'Coordinador Técnico Brasileño en la Comisión Panamericana de Normas Técnicas – COPANT, representando a Brasil en normalizaciones internacionales.'
      },
      {
        period: '2018 - 2019',
        title: 'Coordinador Ejecutivo y Director Sustituto',
        description: 'Coordinador de la Coordinación Ejecutiva y de Gestión de DConf – CEXEC – y Director Sustituto de DConf en INMETRO.'
      },
      {
        period: '2009 - Presente',
        title: 'Especialista y Auditor Líder CGCRE',
        description: 'Especialista externo de la Coordinación General de Acreditación – CGCRE – en INMETRO y Auditor Líder en auditorías en el área eléctrica.'
      }
    ]
  },
  contact: {
    title: 'Póngase en Contacto',
    subtitle: 'Solicite una consultoría especializada y descubra cómo podemos ayudar en la certificación de sus productos',
    phone: 'Teléfono',
    email: 'Correo Electrónico',
    hours: 'Horario de Atención',
    hoursValue: 'Lunes a Viernes: 9h a 18h',
    whyChoose: '¿Por qué elegir APL?',
    reasons: [
      'Más de 19 años de experiencia en certificaciones',
      'Ex-coordinador técnico de INMETRO',
      'Auditor líder en auditorías en el área eléctrica',
      'Asesoría completa y personalizada'
    ],
    formTitle: 'Solicite una Consultoría',
    formName: 'Nombre Completo',
    formEmail: 'Correo Electrónico',
    formPhone: 'Teléfono',
    formCompany: 'Empresa',
    formService: 'Servicio de Interés',
    formMessage: 'Mensaje',
    formNamePlaceholder: 'Su nombre completo',
    formEmailPlaceholder: 'su@email.com',
    formPhonePlaceholder: '(00) 00000-0000',
    formCompanyPlaceholder: 'Nombre de su empresa',
    formServicePlaceholder: 'Seleccione un servicio',
    formMessagePlaceholder: 'Describa sus necesidades de certificación... (máximo 500 caracteres)',
    formMaxChars: 'Máximo 500 caracteres',
    formSubmit: 'Enviar Solicitud',
    formSubmitting: 'Enviando...',
    formSuccess: '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
    formError: 'Error al enviar mensaje. Por favor, intente nuevamente.'
  },
  footer: {
    description: 'Certificación y asesoría técnica con excelencia desde 2005.',
    servicesTitle: 'Servicios',
    contactTitle: 'Contacto',
    hoursTitle: 'Horario',
    hoursValue: 'Lunes a Viernes\n9h a 18h',
    copyright: '© 2024 APL Consultoría y Asesoría Técnica Ltda. Todos los derechos reservados.',
    poweredBy: 'Powered by Readdy'
  }
};
